import { TRACK_PROGRAM_SPLIT_CHANGE_EVENT } from './trackProgramSplitStorage';

function key(workspaceId: string, gradeId: string): string {
  return `cp.trackProgramSyncRep.v1.${workspaceId}.${gradeId}`;
}

export function loadTrackProgramSyncRepMap(workspaceId: string, gradeId: string): Record<string, string> {
  if (!workspaceId || !gradeId) return {};
  try {
    const raw = window.localStorage.getItem(key(workspaceId, gradeId));
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, string> = {};
    Object.entries(parsed as Record<string, unknown>).forEach(([trackName, rep]) => {
      if (!trackName.trim()) return;
      if (typeof rep === 'string' && rep.trim()) out[trackName] = rep.trim();
    });
    return out;
  } catch {
    return {};
  }
}

export function saveTrackProgramSyncRepMap(
  workspaceId: string,
  gradeId: string,
  value: Record<string, string>
): void {
  if (!workspaceId || !gradeId) return;
  try {
    const storageKey = key(workspaceId, gradeId);
    const serialized = JSON.stringify(value);
    if (window.localStorage.getItem(storageKey) === serialized) return;
    window.localStorage.setItem(storageKey, serialized);
    window.dispatchEvent(new CustomEvent(TRACK_PROGRAM_SPLIT_CHANGE_EVENT));
  } catch {
    /* ignore quota */
  }
}
